import {Component} from '@angular/core';
import {FieldComponentAbstract} from '../abstracts/FieldComponentAbstract';
import {MdCheckboxChange} from '@angular/material';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox-field.component.html',
  styleUrls: ['./checkbox-field.component.css']
})
export class CheckboxFieldComponent extends FieldComponentAbstract {

  handleChange(event: MdCheckboxChange) {
    this.fieldValue.check_value = event.checked;
    this.onChange(this.fieldValue);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/fields/components/checkbox-field/checkbox-field.component.ts